var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelatedInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.3 121.3",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.4,52.6h-24c-.7,0-1.3.6-1.3,1.3v8.7h-12.7c-.4,0-.7.3-.7.7v20.7h-8v-9c0-.7-.6-1.3-1.3-1.3H1.3c-.7,0-1.3.6-1.3,1.3v24c0,.7.6,1.3,1.3,1.3h24c.7,0,1.3-.6,1.3-1.3v-9h8v20.7c0,.4.3.7.7.7h12.7v8.7c0,.7.6,1.3,1.3,1.3h24c.7,0,1.3-.6,1.3-1.3v-24c0-.7-.6-1.3-1.3-1.3h-24c-.7,0-1.3.6-1.3,1.3v9.3h-7.3v-36.7h7.3v9.3c0,.7.6,1.3,1.3,1.3h24c.7,0,1.3-.6,1.3-1.3v-24c0-.7-.6-1.3-1.3-1.3ZM20.4,94H6.3v-14h14v14ZM54.4,101h14v14h-14v-14ZM68.4,73h-14v-14h14v14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.2,20.2l-2.5-1.1c-3.5-1.6-6.2-4.5-7.7-8.1l-.9-2.1c-.2-.5-.5-.8-1-1-.9-.4-1.9,0-2.3,1l-.9,2.1c-1.5,3.5-4.3,6.4-7.8,7.9l-2.5,1.1c-.4.2-.7.5-.9.9-.4.9,0,2,.9,2.4l2.6,1.2c3.4,1.6,6.1,4.4,7.6,7.8l.8,2c.2.4.5.8.9.9.9.4,1.9,0,2.3-.9l.9-1.9c1.5-3.4,4.3-6.2,7.7-7.7l2.6-1.1c.4-.2.7-.5.9-.9.4-.9,0-2-.9-2.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.5,47.8c3.4-2.9,4.5-4.5,7-9-4.4-1.2-4.7-1.2-7.6-2-3.4,7.5-10.6,10.3-19.1,9.2-10.5-1.4-17.9-11.1-16.6-21.6,1.4-10.5,11-18,21.6-16.6,3.7.5,6.3,1.1,9,3.4,2.3-1.2,4.1-2.1,6.9-4.2-4.1-4.1-8.8-5.9-14.9-6.8-14.8-1.9-28.3,8.5-30.3,23.2-1.9,14.8,8.5,28.3,23.2,30.3,5,.7,9.8,0,14.1-1.9l14.3,23.3c.6,1,1.7,1.7,2.8,1.8.9.1,1.7,0,2.5-.5,1.8-1.1,2.4-3.5,1.3-5.3l-14.3-23.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatedInfo);
export default __webpack_public_path__ + "static/media/relatedInfo.c3a0f964bf9044176732b03c3c02361a.svg";
export { ForwardRef as ReactComponent };